import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';
import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { AppContext } from '../../contexts/AppContext';
import useSectorService from '../../app/services/hooks/useSectorService';
import { SectorDataForm, SectorFilters } from '../../app/models/Sector';
import SectorDataTable from './components/tables/SectorDataTable';
import SectorCreate from './components/SectorCreate';
import SectorEdit from './components/SectorEdit';
import useNavigationPage from '../../hooks/useNavigationPage';
import { Tab, Tabs } from 'react-bootstrap';
import SectorContainer from './components/SectorContainer';



const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Sectores',
        url: '/sectors',
        isActive: true
    }
];

const Sectors = () => {

    return (
        <>
            <Breadcrumbs pageSection="Sectores" breadcrumbs={breadcrumbs} />

            <DefaultCard>
                        <SectorContainer/>
            </DefaultCard>
        </>
    );
};

export default Sectors;
